<template>
  <div class="menuControll">
    <img src="@/assets/img/head.png" alt="" class="head" />
    <div class="company">
      {{ name }}
    </div>
    <router-link
      @click.native="itemMeun()"
      :to="{ name: 'homeIndex', activeClass: 'router-link-active' }"
      exact
      class="item"
      style="margin-top: 42px"
    >
      <div class="icon icon1"></div>
      信息登记
    </router-link>
    <router-link
      @click.native="itemMeun()"
      exact
      :to="{ name: 'recordTableIndex' }"
      class="item"
    >
      <div class="icon icon2"></div>
      信息登记表
    </router-link>
    <!--    点击导航如果传的是1，那么就是信息更新这个-->
    <router-link
      @click.native="itemMeun(1)"
      exact
      :to="{ name: 'updateIndex' }"
      class="item"
    >
      <div class="icon icon3"></div>
      信息更新
    </router-link>
    <!--    正在开发中-->
    <!--    <router-link-->
    <!--      @click.native="itemMeun(1)"-->
    <!--      exact-->
    <!--      :to="{ name: 'updateDevelop' }"-->
    <!--      class="item"-->
    <!--    >-->
    <!--      <div class="icon icon3"></div>-->
    <!--      信息更新-->
    <!--    </router-link>-->
    <router-link
      @click.native="itemMeun()"
      exact
      :to="{ name: 'setAccount' }"
      class="item"
    >
      <div class="icon icon4"></div>
      账户设置
    </router-link>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getUpdateRecordID } from "@/api/update";
import { getUserInfo } from "@/api/company";

export default {
  name: "Menu",
  data() {
    return {
      isSetPsw: false, //是否设置过密码
      val: 0, //路由导航点击的参数
      isUpdate: false, //通过接口拿到是否能更新
      name: "", //企业名字
    };
  },
  computed: {
    ...mapState(["userinfo"]),
    //绑定手机且修改密码，那么其他菜单栏内容才可显示
    menuShow() {
      if (!this.userinfo.is_set_password || !this.userinfo.phone) {
        return false;
      } else {
        return true;
      }
    },
  },
  created() {
    this.canUpdate();
    this.getUser();
  },
  methods: {
    //获得用户是否有 更新信息的权利
    async canUpdate() {
      const res = await getUpdateRecordID();
      console.log(typeof res);
      if (!res.record_id) {
        // console.log("没有 record_id");
        this.isUpdate = false;
        // this.$message.error("请先完成信息登记");
        return false;
      } else {
        // console.log("有 record_id");
        this.isUpdate = true;
        // this.$router.push({ name: "updateIndex" });
      }
    },
    async getUser() {
      const res = await getUserInfo();
      this.name = res.name;
    },

    itemMeun(val) {
      // console.log("进入temMeun");
      if (!this.userinfo.is_set_password) {
        // this.$message.error("请修改密码！");
        this.$router.push({ name: "setAccount" });
        return false;
      } else if (!this.userinfo.phone && !this.userinfo.company_info.phone) {
        // this.$message.error("请绑定手机号码！");

        //老用户 this.userinfo.company_info.phone this.userinfo.phone两边都会有电话号码，
        //而新用户 只有this.userinfo.company_info.phone一边
        // console.log("------------------99");
        this.$router.push({ name: "setAccount" });
        return false;
      }

      //点击导航如果传的是1，那么就是信息更新这个
      if (val == 1) {
        // console.log("点击了信息更新的按钮");

        // this.canUpdate();

        // this.canUpdate();
        this.val = 1;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.menuControll {
  padding-top: 40px;
  box-sizing: border-box;

  .head {
    width: 50px;
    height: 50px;
    margin: auto;
    display: block;
  }

  .company {
    font-size: 14px;
    color: #333333;
    width: 141px;
    display: block;
    line-height: 18px;
    text-align: center;
    margin: auto;
    margin-top: 20px;
  }

  a {
    display: flex;
    height: 40px;
    align-items: center;
    padding-left: 56px;
    font-size: 14px;
    color: #656565;
    margin-bottom: 10px;
    border-left: 4px solid #fff;
    text-decoration: unset;

    .icon {
      width: 14px;
      height: 14px;
      margin-right: 10px;
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }

    .icon1 {
      background-image: url("~@/assets/img/m1.png");
    }

    .icon2 {
      background-image: url("~@/assets/img/m2.png");
    }

    .icon3 {
      background-image: url("~@/assets/img/m3.png");
    }

    .icon4 {
      background-image: url("~@/assets/img/m4.png");
    }
  }
}

.item {
  transition: all 0.3s;

  &:hover {
    background: #f5f5f5;
    border-left: 4px solid #f5f5f5;
  }
}

.router-link-active {
  background: #e4ecff;
  color: #4379f6 !important;
  border-left: 4px solid #4379f6 !important;

  .icon1 {
    background-image: url("~@/assets/img/m1_b.png") !important;
  }

  .icon2 {
    background-image: url("~@/assets/img/m2_b.png") !important;
  }

  .icon3 {
    background-image: url("~@/assets/img/m3_b.png") !important;
  }

  .icon4 {
    background-image: url("~@/assets/img/m4_b.png") !important;
  }
}
</style>
